<template>
<div class="baseQuse">
    <!--单选-->
    <div class="subjMain" v-if="item.questiontype===1">
        <el-radio-group v-model="item.uselanswer">
            <el-radio v-for="item2 in item.optioninfo" :label="item2.optionsvalue"
                      :class="item2.isrightanswer===1?'yes':'no'" disabled>
                        <span class="iconCheck">
                            <i v-show="item2.isrightanswer===1" class="el-icon-check"></i>
                            <i v-show="item2.isrightanswer!==1&&item.uselanswer===item2.optionsvalue"
                               class="el-icon-close"></i>
                        </span>
                <div class="flex-box">
                    <span v-html="item2.optioncontent"></span>
                    <span class="rightKey" v-if="item2.isrightanswer===1">（正确答案）</span>
                </div>
            </el-radio>
        </el-radio-group>
        <div class="analysis flex-box">解析：<span v-html="item.quesanalysis"></span></div>
    </div>
    <!--多选-->
    <div class="subjMain" v-if="item.questiontype===2">
        <el-checkbox-group v-model="item.uselanswer">
            <el-checkbox v-for="item2 in item.optioninfo" :label="item2.optionsvalue"
                         :class="item2.isrightanswer===1?'yes':'no'" disabled>
                <span class="iconCheck">
                            <i v-show="item2.isrightanswer===1" class="el-icon-check"></i>
                            <i v-show="item2.isrightanswer!==1&&item.uselanswer===item2.optionsvalue"
                               class="el-icon-close"></i>
                        </span>
                <div class="flex-box">
                    <span v-html="item2.optioncontent"></span>
                    <span class="rightKey" v-if="item2.isrightanswer===1">（正确答案）</span>
                </div>
            </el-checkbox>
        </el-checkbox-group>
        <div class="analysis flex-box">解析：<span v-html="item.quesanalysis"></span></div>
    </div>
    <!--不定项选-->
    <div class="subjMain" v-if="item.questiontype===3">
        <el-checkbox-group v-model="item.uselanswer">
            <el-checkbox v-for="item2 in item.optioninfo" :label="item2.optionsvalue"
                         :class="item2.isrightanswer===1?'yes':'no'" disabled>
                <span class="iconCheck">
                    <i v-show="item2.isrightanswer===1" class="el-icon-check"></i>
                    <i v-show="item2.isrightanswer!==1&&item.uselanswer===item2.optionsvalue" class="el-icon-close"></i>
                </span>
                <div class="flex-box">
                    <span v-html="item2.optioncontent"></span>
                    <span class="rightKey" v-if="item2.isrightanswer===1">（正确答案）</span>
                </div>
            </el-checkbox>
        </el-checkbox-group>
        <div class="analysis flex-box">解析：<span v-html="item.quesanalysis"></span></div>
    </div>
    <!--判断-->
    <div class="subjMain" v-if="item.questiontype===4">
        <el-radio-group v-model="item.userValue">
            <el-radio v-for="list in judgeList" :label="list.label" :class="item.judgeValue?'yes':'no'" disabled>
                <!--<span class="iconCheck" v-show="item.judgeValue===list.label">-->
                <!--<i :class="list.label===item.judgeValue?'el-icon-check':'el-icon-close'"></i>-->
                <!--</span>-->
                <span class="iconCheck">
                    <i v-show="item.judgeValue===list.label" class="el-icon-check"></i>
                    <i v-show="item.judgeValue!==list.label && list.label===item.userValue" class="el-icon-close"></i>
                </span>
                <span>{{list.value}}</span>
            </el-radio>
        </el-radio-group>
        <div class="analysis flex-box">解析：<span v-html="item.quesanalysis"></span></div>
    </div>
    <!--填空-->
    <div class="subjMain" v-if="item.questiontype===5">
        <div v-for="(item2,index) in item.uselanswer" class="writeMargin">
            <span class="iconWrite">
                <i :class="item.finalanswerblank.answerblank[index]===item2?'el-icon-check':'el-icon-close'"></i>
            </span>
            <span class="indexNub">{{index+1}}</span>
            <span class="hasLine">{{item2}}</span>
        </div>
        <div class="writeMargin">正确答案:
            <span>{{item.finalanswerblank.answerblank.join(',')}}</span>
        </div>
        <div class="analysis flex-box">解析：<span v-html="item.quesanalysis"></span></div>
    </div>
</div>
</template>

<script>
export default {
    name: 'baseQuse',
    props: ['item'],
    data() {
        return {
            judgeList: [{
                value: '正确',
                label: 1,
                select: 1
            }, {
                value: '错误',
                label: 0,
                status: 1,
            }]
        }
    },
    mounted() {
    },
    methods: {},
    filters: {},
    watch: {},
    computed: {},
    components: {}
}
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
.baseQuse {
.el-checkbox__input{
    align-self: flex-start;
    line-height: 25px;
}
}
</style>
